export default {
  save: 'Save configuration',
  saved: 'Process config saved',
  add: 'Add a processing element',
  goto_start: 'goto start',
  change_source: 'change source',
  check_sources: 'Check sources',
  server_offline: 'Server is offline',
  advanced_parameters: 'Advanced parameters',
  save_advanced_parameters: 'Save advanced parameters',
  advanced_saved: 'Advanced parameters saved',
  wrong_coordinates_format: 'Wrong coordinate format',
  save_to_file: 'Save to file',
  fast_forward: 'Run at max-speed (files)',
  offline: 'Server is offline',
  modals: {
    changeSource: 'Change source',
    configuredSources: 'Configured sources',
    addProcessor: 'Add a processor',
    addModel: 'Add a model',
    loadedModels: 'Loaded models',
    addOutput: 'Add an output',
    configuredOutputs: 'Configured outputs'
  }
}
